module.exports = __webpack_public_path__ + "img/scuba_600.63bb585b.png";